export default {
  methods: {
    resizeImage(path, width, height, quality = 50) {
      if (process.env.PROD) {
        return `/cdn-cgi/image/width=${width},height=${height},quality=${quality},format=auto${path}`;
      }

      return path;
    },
  },
};
